import * as React from "react";
import { IsSessionExpiredContext } from "src/modules/Auth/AuthExpiration/AuthExpirationContext";

export const useIsSessionExpired = (): boolean => {
  const [isExpired] = React.useContext(IsSessionExpiredContext)
  return isExpired;
}